module.exports = __webpack_public_path__ + "static/media/iconmonstr-media-control-49.6a4c19a3.svg";